import { STEPS } from "../content/steps";
import { Icon } from "./Icon";
import "./styles/HowItWorks.css";

export function HowItWorks() {
  return (
    <ol className="how-it-works__steps">
      {STEPS.map((step, index) => (
        <li key={step.id} className="how-it-works__step">
          <span className="how-it-works__number" aria-hidden="true">{index + 1}</span>
          <span className="how-it-works__icon"><Icon name={step.icon} /></span>
          <h2>{step.title}</h2>
          <p>{step.description}</p>
        </li>
      ))}
    </ol>
  );
}
